import {IController} from "../../../controllers/IController";
import {InjectionToken} from "@angular/core";
import {ModelKey} from "../../../models/ModelKey";
import {EntitySelectionDropdownModel} from "../_models/EntitySelectionDropdownModel";

export const IT_ENTITY_SELECTION_DROPDOWN_CONTROLLER = new InjectionToken<IEntitySelectionDropdownController>('IT_ENTITY_SELECTION_DROPDOWN_CONTROLLER');

export const MK_ENTITY_SELECTION_DROPDOWN = new ModelKey<EntitySelectionDropdownModel>('MK_ENTITY_SELECTION_DROPDOWN');

export interface IEntitySelectionDropdownController extends IController {

  handleInitialConfig(eventData: any): void;
  handleInitialSelectedItems(eventData: any): void;
  handleEndOfList(eventData: any): void;
  handleItemSearch(eventData: any): void;
}
